import AssetTabs from './AssetTabs';

export default AssetTabs;

export { default as AssetTab } from './AssetTab';
